// extracted by mini-css-extract-plugin
export default {"ScrollTransition":"ScrollTransition_igGyl","ScrollTransition___visible":"ScrollTransition___visible_QrQuf"};